import React, {useMemo} from "react";
import {ConfigProvider, Tabs} from "antd";
import {useLocation} from "react-router-dom";
import {Redirect, Route, Switch} from "react-router";
import {extractTabFromUrl} from "./DefaultAppDashboard.jsx";
import {ResponsiveView} from "../components";
import {DriverDeliveriesWrapper} from "../delivery/driverDeliveries/DriverDeliveriesWrapper.jsx";
import {Devices} from "../components/ResponsiveView/consts.js";

const {TabPane} = Tabs;

export const DriverDashboard = ({history}) => {
    const location = useLocation();

    const activeKey = useMemo(() => {
        const routes = ["mydeliveries"];

        return extractTabFromUrl(RegExp(`^\/dashboard\/(${routes.join("|")})(.*)$`));
    }, [location.pathname]);

    return !activeKey ? (
        <Redirect to="/dashboard/mydeliveries" />
    ) : (
        <ConfigProvider direction="rtl">
            <Switch>
                <Route exact={true} path="/dashboard/mydeliveries" component={DriverDeliveriesWrapper} />
            </Switch>

            <ResponsiveView devices={[Devices.desktop]}>
                <Tabs
                    activeKey={activeKey}
                    onTabClick={key => history.push(`/dashboard/${key}`)}
                    centered={true}
                    className="provider-dashboard-tabs">
                    <TabPane tab="המשלוחים שלי" key="mydeliveries" />
                </Tabs>
            </ResponsiveView>
        </ConfigProvider>
    );
};
